import App from './App.svelte';
import OpKpisApp from './OperationsApp.svelte'; 

const KpisComponentInit = !ENVIRONMENT.IS_OPERATIONS_KPIS ? App : OpKpisApp;
const app = new KpisComponentInit({
	target: document.body
});

export default app;